import { actionCreatorFactory } from 'typescript-fsa'

const actionCreator = actionCreatorFactory('Home')

export const checkForUpdates = actionCreator('CHECK_FOR_UPDATES')